module.exports = __webpack_public_path__ + "static/media/flag-bg.0a59f95f.webp";